import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AqlCommonService {
  constructor() {}

  public create_UUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

  public generateUniqueNumber() {
    const timestamp = Date.now();
    const randomNum = Math.floor(Math.random() * 100000);
    const uniqueNumber = `${timestamp}${randomNum}`;

    return parseInt(uniqueNumber, 10); // Return as an integer
  }

  transformToMasterDataList(itemList: string[]) {
    return itemList.map((item, index) => {
      return {
        category_id: '',
        name: item,
        id: item,
        group_id: [],
        group_name: '',
      };
    });
  }
}
